<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<!--HEADER CONTAINER-->
<div class="header-container">
  <div>
    <h1 id="header-text">Load GFS Propulsion Portfolio</h1>
  </div>

  <div class="export-current-portfolio-container">
    <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedPortType">
      <mat-radio-button [value]="BUSINESS_PLAN">{{ BUSINESS_PLAN }}</mat-radio-button>

      <mat-radio-button class="radio-options" [value]="TVP">{{ TVP }}</mat-radio-button>
    </mat-radio-group>
    <br/>
    <button mat-raised-button id="export-current-portfolio-button"
            class="export-current-portfolio-button"
            color="primary"
            (click)="exportCurrentPortfolioByPortType(selectedPortType)">Export Current Portfolio
    </button>
  </div>

  <div class="options">
    <div>
      <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                         (eventEmitter)="upload($event)"></app-upload-button>

      <app-export-button id="export-button" class="no-custom-text"
                         [disabled]="!hasData"
                         [color]="exportButtonColor"
                         [excelExportService]="excelService"
                         [worksheetExportRequest]="worksheetExportRequest">
        Export
      </app-export-button>

      <button mat-raised-button color="warn" id="delete-button" class="action-button"
              [disabled]="rowsToDelete.length === 0"
              (click)="delete()">
        Delete
      </button>

      <button mat-raised-button color="primary" id="load-button" class="action-button"
              (click)="validate(portfolioData)"
              [disabled]="isLoadButtonDisabled">
        Load
      </button>

      <mat-checkbox class="checkbox initial-load" [(ngModel)]="isInitialLoad"
                    matTooltip="If checked, GFS will treat the load file as a complete load for each
  Forecast Org represented, clearing out all FC records in the portfolio prior to load.

  If not checked, the load file will be treated as a partial load
  and GFS will determine for each record if it is an add/change.">Initial Load
      </mat-checkbox>
    </div>
  </div>
</div>
<!-- Tabs -->
<mat-tab-group mat-stretch-tabs="false" #portfolioTabGroup *ngIf="portfolioTabs.length > 0"
               (selectedTabChange)="fcorgTabChange($event)"
               [(selectedIndex)]="fcorgTabIndex">
  <mat-tab *ngFor="let tab of portfolioTabs" [label]="tab" id="{{tab}}"></mat-tab>
</mat-tab-group>

<!-- Violation Tabs -->
<mat-tab-group mat-stretch-tabs="false" #violationTabGroup *ngIf="hasViolations"
               (selectedTabChange)="violationTabChange($event)"
               [(selectedIndex)]="violationTabIndex">
  <mat-tab label="Eng Rules Violation" id="duplicateEngDtlTab"
           *ngIf="violations.duplicateEngList.length > 0"></mat-tab>
  <mat-tab label="Trans Rules Violation" id="duplicateTranDtlTab"
           *ngIf="violations.duplicateTranList.length > 0"></mat-tab>
  <mat-tab label="Battery Rules Violation" id="duplicateBatTab"
           *ngIf="violations.duplicateBatList.length > 0"></mat-tab>
  <mat-tab label="Electr Rules Violation" id="duplicateElecTab"
           *ngIf="violations.duplicateElecList.length > 0"></mat-tab>
  <mat-tab label="PrimDr Rules Violation" id="duplicatePriDrvTab"
           *ngIf="violations.duplicatePriDrvList.length > 0"></mat-tab>
  <mat-tab label="SecDr Rules Violation" id="duplicateSecDrvTab"
           *ngIf="violations.duplicateSecDrvList.length > 0"></mat-tab>
  <mat-tab label="Duplicate Id Records" id="duplicateIdTab" *ngIf="violations.duplicateIdList.length > 0"></mat-tab>
  <mat-tab label="Invalid Port Type Records" id="invalidPortTypeTab"
           *ngIf="violations.invalidPortTypeList.length > 0"></mat-tab>
  <mat-tab label="Date Violations" id="dateViolations" *ngIf="violations.dateViolations.length > 0"></mat-tab>
</mat-tab-group>

<!-- Result Tabs -->
<mat-tab-group mat-stretch-tabs="false" #resultTabGroup *ngIf="hasResults" (selectedTabChange)="resultTabChange($event)"
               [(selectedIndex)]="resultTabIndex">
  <mat-tab label="Portfolio" id="portfolio" *ngIf="propPortLoadResults.portfolio.length > 0"></mat-tab>
  <mat-tab label="Prop No Veh" id="propNoVeh" *ngIf="propPortLoadResults.propNoVehList.length > 0"></mat-tab>
  <mat-tab label="Veh No Prop" id="vehNoProp" *ngIf="propPortLoadResults.vehNoPropList.length > 0"></mat-tab>
  <mat-tab label="New Adds" id="newAdds" *ngIf="!isAddUpdateTabDisabled"></mat-tab>
  <mat-tab label="Update Records" id="updateRecords" *ngIf="!isAddUpdateTabDisabled"></mat-tab>
  <mat-tab label="No Change Records" id="noChangeRecords"
           *ngIf="propPortLoadResults.noChangeRecords.length > 0 && !isAddUpdateTabDisabled"></mat-tab>
  <mat-tab label="Duplicate Records" id="duplicateRecords"
           *ngIf="propPortLoadResults.duplicateRecords.length > 0"></mat-tab>
</mat-tab-group>
<!--  Tables-->
<!--    Main Option Table-->
<div class="h-100" *ngIf="hasData || hasViolations">
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%;"
      class="ag-theme-quartz"
      [rowData]="displayedData"
      [columnDefs]="displayedColDef"
      [rowSelection]="rowSelection"
      (rowSelected)="onSelect($event)"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
      [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>
